import axios from "axios";
import { notifyTokenExpired } from "../common/tokenExpiry";
import { logout } from "../utils/auth";

export const axiosInstance = axios.create({
    // baseURL: 'https://hrms-prodapi.hashstack.in',   //Production
    baseURL: "https://hrmsstagingapi.hashstack.in",    //Staging
    // baseURL: "http://localhost:3900",
    withCredentials: true,
});

// attach token if exists
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("authToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Handle unauthorized/expired token responses - show global dialog and clear auth
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        const message =
            error.response?.data?.message?.msg ||
            error.response?.data?.message ||
            "";

        const isTokenExpired =
            status === 401 ||
            (status === 403 && /token\s*expired/i.test(message));

        if (isTokenExpired) {
            logout();
            notifyTokenExpired();
        }

        return Promise.reject(error);
    }
);

export async function postData(url, payload) {
    const config =
        payload instanceof FormData
            ? { headers: { "Content-Type": "multipart/form-data" } }
            : {};
    const res = await axiosInstance.post(url, payload, config);
    return res.data;
}

export async function getData(url, params) {
    const res = await axiosInstance.get(url, { params });
    return res.data;
}

export async function putData(url, payload) {
    const config =
        payload instanceof FormData
            ? { headers: { "Content-Type": "multipart/form-data" } }
            : {};

    const res = await axiosInstance.put(url, payload, config);
    return res.data;
}

export async function deleteData(url) {
    const res = await axiosInstance.delete(url);
    return res.data;
}